<template>
  <router-view />
  <CookieBanner />
</template>

<script setup lang="ts">
import CookieBanner from './components/CookieBanner.vue';
</script>
